import React from 'react'
import { WinnerList } from 'src/pages/worldCup2026/winners/list'

export const WorldCup2026WinnersPage = () => {
  return <WinnerList />
}
